import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';

import { Logger } from './../logger.service';
const log = new Logger('site-info');

import { IChambre, IComment } from '@app/shared';
import { Room } from './../models/room.model';
import { forEach, values, filter, map, intersection, find, shuffle, has, keys, max } from 'lodash';

const routes = {
    siteinfo: '/site-info',
};

@Injectable({
    providedIn: 'root'
})
export class SiteInfosService {
    private _data: any;

    constructor(private apiService: ApiService) {
        log.warn('create  SiteInfosService');
    }

    /**
     * load data siteInfos - used by module core
     */
    load(idEtab): Promise<any> {
        let params = new HttpParams({
            fromObject: {
                idEtab: idEtab,
            }
        });
        let promise = this.apiService.get(routes.siteinfo, params).toPromise();
        promise.then(response => {
            log.warn('loadSiteInfo response');
            this._data = response;
        });
        return promise;
    }

    /**
     * get data room by id
     * @returns
     */
    getDataChambre(idRoom) {
        if (this._data.chamber && this._data.chamber[idRoom] != undefined)
            return this._data.chamber[idRoom];
        return null
    }

    /**
     * list rooms
     */
    getChambre(): Array<Room> {
        let rooms: Array<Room> = [];
        forEach(this._data.chamber, (value: IChambre) => {
            if (!value.isDeleted)
                return rooms.push(new Room(value))
        });
        return rooms;
    }

    /**
     * add new room (from push)
     */
    addChamber(value: IChambre): boolean {
        if (!has(this._data.chamber, value.id)) {
            this._data.chamber[value.id] = value;
            return true;
        }
        return false;
    }

    /**
     * liste OTA activie
     */
    getlistOtas(): Array<string> {
        return this.getEtabData()['etabEngine'];
    }

    /**
     * liste langues
     */
    getlistLangs(): Array<string> {
        return values(this._data['lang']);
    }
    /**
     * Get Lang By Code EX : fr
     */
    getLangByCode(code: string): object {
        if (has(this._data['lang'], code.toLocaleLowerCase())) {
            return this._data['lang'][code.toLocaleLowerCase()];
        }
        return {
            "idLangue": null,
            "titre": code,
            "code": code,
            "description": code,
            "oldId": null
        };
    }
    /**
     * List Etab Valide lang
     * @returns {}
     */
    getetabLangs(): Array<{}> {
        return this.getEtabData()['etabLang'];
    }
    /**
     * List Etab Valide lang
     * @returns {}
     */
    getlistCurrency(): Array<{}> {
        return this._data['currency'];
    }
    /**
     * get List des Service
     * @return Array
     */
    getService(): Array<{}> {
        return this._data['Service'];
    }
    /**
     * List des Service Meal Plan
     * @param idRoom  number
     * @param idLine  number
     * @returns Array
     */
    getCombineService(idRoom: number, idLine: number): Array<{}> {
        let service = this.getService();
        let combineservice = this._data['combineservice'][idRoom + '_' + idLine];
        let mealPlanService = filter(service, { 'typeService': "meal plan" });
        let mealPlanCombine = intersection(map(mealPlanService, 'serviceId'), map(combineservice, 'sid'));
        let result = [];
        forEach(mealPlanCombine, (idService) => {
            let data = find(combineservice, { 'sid': idService });
            let dataService = JSON.parse(JSON.stringify(service[idService]));
            dataService.inc = data.inc;
            result.push(dataService)
        });
        return result;
    }
    getlistFacilities(): Array<{}> {
        return this._data['facilities'];
    }
    /**
     * list card dispo ex : ["visa", "euromastercard"]
     * @returns Array<string>
     */
    getListCard(): Array<string> {
        return this.getEtabData()['txCard'];
    }

    /**
     *
     */
    getEtabData(): Array<{}> {
        return this._data['etablissment'] != undefined ? this._data['etablissment'] : this._data['etablissement'];
    }
    /**
     *
     */
    getEtabLastHours(): any {
        return this.getEtabData()['etabLastHours'] ? this.getEtabData()['etabLastHours'] : '24:00';
        //        return this.getEtabData()['etabLastHours'] ? this.getEtabData()['etabLastHours'] : '00:00';//bug 
    }

    /**
     * get name etablissement
     * @returns string
     */
    getEtbaName(): string {
        return this.getEtabData()['etablissementNom'];
    }

    /**
     * get city of etablissement
     * @returns string
     */
    getEtbaCity(): string {
        return this.getEtabData()['etabVille'];
    }
    /**
     * get country of etablissement
     * @returns string
     */
    getEtbaCountry(): string {
        return this.getEtabData()['etabPays'];
    }

    /**
     * get Currency etablissement
     * @returns string
     */
    getEtabCurrency(): string {
        return this.getEtabData()['etabCurrency'];
    }

    /**
     * get id fineprint
     * @returns number
     */
    getIdFineprint(): number {
        let id = parseInt(this._data['fineprinte']);
        if (isNaN(id))
            return 0;
        return id;
    }

    /**
     * get good to know
     * @returns Array<{}>
     */
    getGoodToKnow(): Array<{}> {
        return this._data['goodtoknow'];
    }

    /**
     * comments
     * @returns Array<IComment>
     */
    getCommentByLang(lang): Array<IComment> {
        let langEn = 'en'
            , langEnId = 2
            , comments: Array<IComment> = []
            , commentsTrip = this._data['comments']['TripAdvisor']
            , commentsBooking = this._data['comments']['booking']
            ;

        let langObj = this.getLangByCode(lang);
        let langId = langObj['idLangue'];

        if (commentsBooking != undefined) {
            let entries : Array<IComment> = [];
            if (commentsBooking[lang]) entries = entries.concat(commentsBooking[lang]);
            if (langId && commentsBooking[langId] && langId != lang) entries = entries.concat(commentsBooking[langId]);
            entries = entries.filter(c => !!c.commentTextPost);

            if (entries.length === 0) {
                entries = commentsBooking[langEn] || commentsBooking[langEnId] || [];
            }
            comments = comments.concat(entries);
        }

        if (commentsTrip != undefined) {
            let entries : Array<IComment> = [];
            if (commentsTrip[lang]) entries = entries.concat(commentsTrip[lang]);
            if (langId && commentsTrip[langId] && langId != lang) entries = entries.concat(commentsTrip[langId]);
            entries = entries.filter(c => !!c.commentTextPost);

            if (entries.length === 0) {
                entries = commentsTrip[langEn] || commentsTrip[langEnId] || [];
            }
            comments = comments.concat(entries);
        }

        return shuffle(comments);
    }


    getPopulairFacilities(): string {
        //Fix bug text
        if (has(this._data, 'populairacilities')) {
            return this._data['populairacilities'];
        }
        return this._data['populairfacilities'];
    }
    getLandMarks(): string {
        return this._data['landmark'];
    }

    /**
     * 
     */
    getChambreBasic(): Room {
        let value = find(this._data.chamber, { 'isBookingBasic': true });
        return new Room(value);
    }

    getPhonecode(): Array<any> {
        let phonecode = [];
        if (!!this._data.phonecode) {
            return this._data.phonecode;
        }
        return phonecode;
    }
}
